import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import GroheCategoriesMenu from "./groheCategoriesMenu";
import {ROUTES} from "../../../../../routes";
import {getRoomName} from "../../../../../misc/helpers";

const GroheCategories = (props) => {

  const {lookPageOpened, isMobile, subCategoryOpened, intl, fabricatorData, quotes, shopPageOpened} = props;
  const categoriesOpened = lookPageOpened === ROUTES.category;

  const roomName = getRoomName(0, [], quotes, intl.messages, intl.locale, fabricatorData).toLowerCase()

  return (
    <section className={"grohe-section grohe-section--categories"
      + (categoriesOpened ? " grohe-section--opened" : "")
      + (shopPageOpened ? " grohe-section--shop" : "")
      + (subCategoryOpened ? " grohe-section--full grohe-section--opened--more" : "")}>
      {isMobile ? null : (
        <h2 className={"grohe-section__title" + (subCategoryOpened ? " grohe-section__title--with-top" : "")}>
          <FormattedMessage id="grohe.categories.title"/>
        </h2>
      )}
      {isMobile ? null : (
        <p className="grohe-section__description">
          <FormattedMessage id="grohe.categories.description" values={{roomName}}/>
        </p>
      )}
      {categoriesOpened ? <GroheCategoriesMenu showWizardItems={true}/> : null}
    </section>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened} = store.lookState;
  const {isMobile} = store.serverState;
  const {subCategoryOpened} = store.groheState;
  const {quotes} = store.quotesState;
  const fabricatorData = store.fabricatorState;
  const {shopPageOpened} = store.shopState;

  return {
    lookPageOpened,
    isMobile,
    subCategoryOpened,
    quotes,
    fabricatorData,
    shopPageOpened,
  };
};

export default injectIntl(
  connect(mapStateToProps)(GroheCategories)
)
